import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { omit } from 'lodash';
import { Consumer } from './ModalProvider';

class Modal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.id = props.id || uuidv4();
    this.componentDidUpdate();
  }

  render = () => null;

  componentDidUpdate = () => (this.isActive || this.props.isOpen) && this.updateModal();

  activate = () => (this.isActive = true);
  deactivate = () => (this.isActive = false);

  updateModal = () => {
    const {
      isOpen,
      children: modalComponent,
      onEscapeKeydown,
      onBackgroundClick,
      beforeOpen,
      afterOpen,
      beforeClose,
      afterClose,
      addModal,
      ...restModalProps
    } = this.props;

    this.activate();

    addModal(this.id, {
      restModalProps: omit(restModalProps, 'id'),
      isOpen,
      modalComponent,
      onEscapeKeydown,
      onBackgroundClick,
      beforeOpen,
      afterOpen,
      beforeClose,
      afterClose,
      deactivate: this.deactivate,
    });
  };
}

const withContext = (Component) => (props) => <Consumer>{({ addModal }) => <Component {...{ ...props, addModal }} />}</Consumer>;

export default withContext(Modal);
